import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from 'components/link-button/link-button';
import useBreakpoints from 'hooks/use-breakpoints';
import cn from 'classnames';

const RelatedItemsHeader = ({
  heading,
  seeAllLink,
  useVerticalLayout = false,
  className,
}) => {
  const { isDesktop } = useBreakpoints(false);
  return (
    <div
      className={cn('related-items-header', className, {
        'related-items-header_vertical': useVerticalLayout,
      })}
    >
      {heading && <h2 className="related-items-header__heading">{heading}</h2>}
      {isDesktop && seeAllLink && (
        <LinkButton
          {...seeAllLink}
          className="related-items-header__see-all-button"
        />
      )}
    </div>
  );
};

RelatedItemsHeader.propTypes = {
  heading: PropTypes.string,
  seeAllLink: PropTypes.exact(LinkButton.propTypes),
  useVerticalLayout: PropTypes.bool,
  className: PropTypes.string,
};

RelatedItemsHeader.viewModelMeta = 'ignore';

export default RelatedItemsHeader;
